import { Tooltip, styled } from '@material-ui/core';

import { RiErrorWarningLine } from '@remixicon/react';

const ICON_SIZE = 28;

const StaleBadge = styled('div')({
  position: 'absolute',
  top: '-10px',
  right: '-10px',
  backgroundColor: 'var(--background-base)',
  borderRadius: '50%',
  height: ICON_SIZE,
  width: ICON_SIZE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

type StaleMetricBadgeProps = {
  tooltip?: string;
};

export const StaleMetricBadge = ({ tooltip }: StaleMetricBadgeProps) => {
  return (
    <Tooltip title={tooltip || 'Metric data has changed since this was added'}>
      <StaleBadge>
        <RiErrorWarningLine color="var(--essential-warning)" size={ICON_SIZE} />
      </StaleBadge>
    </Tooltip>
  );
};
